import type { BookingOverlapWarning } from '@cdf/api-client-react';

export interface OverlapReview {
  warning: BookingOverlapWarning;
  decide: (bookAnyway: boolean) => void;
}

/** One decision per submission, with cancellation on scope change or unmount. */
export function createBookingOverlapController(show: (review: OverlapReview | null) => void) {
  let pending: ((value: string | null) => void) | null = null;
  return {
    review(warning: BookingOverlapWarning): Promise<string | null> {
      if (pending) return Promise.resolve(null);
      return new Promise((resolve) => {
        pending = resolve;
        show({ warning, decide(bookAnyway) {
          if (pending !== resolve) return;
          pending = null;
          show(null);
          resolve(bookAnyway ? warning.acknowledgement : null);
        } });
      });
    },
    cancel() {
      const resolve = pending;
      pending = null;
      show(null);
      resolve?.(null);
    }
  };
}
